import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestGetKBTags() {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/kb/tags`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetKBArticles(params) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/kb`,
        params,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetKBArticle(id) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/kb/${id}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateKBArticle(data) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/kb`,
        data,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestCreateKBArticleFromProject(projectId, data) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/kb/from-project/${projectId}`,
        data,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestKBAIRewrite(projectId, data) {
    return axios.request({
        method: 'post',
        url: `${getApiUrl()}/kb/from-project/${projectId}/ai-rewrite`,
        data,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestUpdateKBArticle(id, data) {
    return axios.request({
        method: 'put',
        url: `${getApiUrl()}/kb/${id}`,
        data,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDeleteKBArticle(id) {
    return axios.request({
        method: 'delete',
        url: `${getApiUrl()}/kb/${id}`,
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetKBArticleVersions(id) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/kb/${id}/versions`,
        withCredentials: true,
        crossorigin: true,
    });
}
